import { AdherentMapData } from '../../store/slices/dashboardSlice';

/**
 * Address format expected by the mapping components
 */
export interface Address {
  id: string;
  adresse: string;
  commune: string;
  codePostal: string;
  locauxCount: number;
  numeroVoirie?: string;
  libelleVoie?: string;
  codeInsee?: string;
  codeDepartement?: string;
  // Custom fields for our adherent data
  adherentId?: number;
  siret?: string;
  denominationUniteLegale?: string;
  // Entrepreneur individuel fields
  nomUniteLegale?: string;
  prenom1UniteLegale?: string;
  denominationUsuelleEtablissement?: string;
}

/**
 * Address with geocoding information
 */
export interface GeocodedAddress extends Address {
  latitude: number;
  longitude: number;
  geocoded: boolean;
}

/**
 * Props for the adherent map component
 */
export interface AdherentMapProps {
  adherents: AdherentMapData[];
  isLoading: boolean;
  className?: string;
}

/**
 * Loading state interface
 */
export interface LoadingState {
  total: number;
  completed: number;
  failed: number;
  isComplete: boolean;
  error?: string;
}

/**
 * Convert adherent map data to addresses for geocoding
 */
export const convertToAddresses = (adherents: AdherentMapData[]): Address[] => {
  return adherents.map(adherent => ({
    id: adherent.id.toString(),
    adresse: adherent.locationData.adresse,
    commune: adherent.locationData.commune,
    codePostal: adherent.locationData.codePostal,
    locauxCount: adherent.locationData.locauxCount,
    numeroVoirie: adherent.locationData.numeroVoirie,
    libelleVoie: adherent.locationData.libelleVoie,
    codeInsee: adherent.locationData.codeInsee,
    codeDepartement: adherent.locationData.codeDepartement,
    // Custom fields
    adherentId: adherent.id,
    siret: adherent.siret,
    denominationUniteLegale: adherent.bigData?.uniteLegale?.denominationUniteLegale,
    // Entrepreneur individuel fields
    nomUniteLegale: adherent.bigData?.uniteLegale?.nomUniteLegale,
    prenom1UniteLegale: adherent.bigData?.uniteLegale?.prenom1UniteLegale,
    denominationUsuelleEtablissement: adherent.bigData?.etablissement?.denominationUsuelleEtablissement
  }));
}; 